import { cloneDeep } from 'lodash';
import React from 'react';
import { Typography } from '@mui/material';
import { assign } from 'xstate';
import { IntlShape } from 'react-intl';

import { MachineContext } from '../../MachineContext';
import { BaseComponent } from '../Component';
import { translateWithFallback } from '../../util';

import { useStyles } from './PostIt.styles';

export interface PostItDisplayComponent extends BaseComponent {
  type: 'postItDisplay';
  props: PostItDisplayProps;
}

export interface PostItDisplayProps {
  message: string;
  title: string;
  headline?: string;
  minWidth?: number;
  maxWidth?: number;
  isEcho?: boolean;
}

export const PostItDisplay: React.FC<PostItDisplayProps> = ({
  message,
  title,
  headline,
  minWidth = 200,
  maxWidth = 250,
}) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div
        className={classes.postIt}
        style={{ minWidth: minWidth, maxWidth: maxWidth }}
      >
        <Typography className={classes.headline} variant="h5">
          {headline}
        </Typography>
        <Typography className={classes.title} variant="h6">
          {title}
        </Typography>

        <div className={classes.message}>
          <Typography variant="body2">{message}</Typography>
        </div>
      </div>
    </React.Fragment>
  );
};

export const renderPostItDisplayAction = (intl: IntlShape) => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    const payload = actionMetadata.action.payload;
    const postitmessage = context.userData[payload.getValueFrom];
    newContext.widgetData.push({
      type: 'postItDisplay',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        title: translateWithFallback(intl, payload.title),
        headline: translateWithFallback(intl, payload.headline),
        message: postitmessage,
        isEcho: payload.isEcho,
      },
    });
    return newContext;
  });
};
